<template>
    <div>
			<CreationHeader />

			<b-container fluid>
				<b-row>
					<b-col cols="12" xl="8">
						<CreationStepper />

						<CreationFooter />
					</b-col>

					<b-col class="d-none d-xl-block p-3 bg-light sticky-top h-100" align-self="baseline">
						<CreationSummary
						:company="services.creation.company"
						:particulars="services.creation.particulars"
						:packs="services.creation.packs"
						:options="services.creation.options"
						:price="services.creation.price"
						/>
					</b-col>
				</b-row>
			</b-container>

			<CreationHelpModal />
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    import CreationHeader from '../../components/creation/CreationHeader.vue';
    import CreationStepper from '../../components/creation/CreationStepper.vue';
    import CreationSummary from '../../components/creation/CreationSummary.vue';
    import CreationHelpModal from '../../components/creation/CreationHelpModal.vue';
    import CreationFooter from '../../components/creation/CreationFooter.vue';

    export default {
			components: {
				CreationHeader,
				CreationStepper,
				CreationSummary,
				CreationHelpModal,
				CreationFooter
			},
			computed: {
				...mapState(['services'])
			}
    }
</script>
